<template>
  <div>
    <header-component />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isDataFetched" class="com_page_title1">
    <div class="com_inner1 clearfix">
      <div class="block1">
        <img
          src="@/assets/common/img/event-list_title.png"
          alt=""
          class="image1"
        />
      </div>
    </div>
  </div>
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="apiErrorMessage" class="error-message">
        {{ apiErrorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <!-- エラーメッセージの表示エリア -->
    <div v-if="apiErrorMessage" class="com_inner1 error-message">
      {{ apiErrorMessage }}
    </div>
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <div class="com_contents3">
          <div class="main_column2">
            <template v-if="isEventList">
              <!-- 申し込み済のイベント -->
              <div class="com_i_title1 a">
                <div>
                  <img
                    src="@/assets/common/img/icon-t-event2.png"
                    alt=""
                    class="icon-t-event2"
                  />
                  <h2>申し込み済のイベント</h2>
                </div>
              </div>

              <div
                class="com_thumb_list1 th1 com_more2"
                :class="{ open: isApplicationEventOpen }"
              >
                <router-link
                  v-for="item in applicationEventDisplayedList"
                  :key="item.contentsId"
                  class="item1"
                  :to="`/skilup-event-detail/categoryId/${item.categoryId}/contentsId/${item.contentsId}`"
                >
                  <div class="test">
                    <a href="" class="thumb1 b">
                      <img
                        :src="`/${item.thumbnailPath}/${item.thumbnailName}`"
                        alt=""
                        @error="handleImageError(item)"
                      />
                    </a>
                  </div>
                  <div>
                    <div class="meta1 a">
                      <span class="com_fs14">
                        {{ formatEventDate(item.eventDate) }}
                      </span>
                      <span class="com_tag2">{{ item.subCategoryName }}</span>
                      <span v-if="item.newFlg" class="com_new1">NEW</span>
                      <div v-if="item.closeFlg" class="close-event">
                        受付終了
                      </div>
                    </div>
                    <div class="body1">
                      <h2 class="com_link1">
                        {{ item.contentsTitle }}
                      </h2>
                    </div>
                  </div>
                  <div v-if="isKaunetAdmin" class="edit1">
                    <a
                      href="#"
                      @click.prevent="
                        editContents(item.categoryId, item.contentsId)
                      "
                      class="com_edit1"
                    >
                      <span></span>
                    </a>
                  </div>
                </router-link>
                <a
                  href="#"
                  v-if="applicationEventListData.length > appDispCount"
                  @click.prevent="toggleApplicationEventOpen"
                  class="com_more_button2"
                >
                  <span v-if="isApplicationEventOpen">閉じる</span>
                  <span v-else>もっと見る</span>
                </a>
              </div>

              <!-- イベント一覧 -->
              <div class="com_i_title1 a com_mgt45">
                <div>
                  <img
                    src="@/assets/common/img/icon-t-event1.png"
                    alt=""
                    class="icon-t-event1"
                  />
                  <h2>イベント一覧</h2>
                </div>
              </div>

              <div class="com_thumb_list1 th1 com_more2">
                <router-link
                  v-for="item in eventListData"
                  :key="item.contentsId"
                  class="item1"
                  :to="`/skilup-event-detail/categoryId/${item.categoryId}/contentsId/${item.contentsId}`"
                >
                  <div>
                    <a href="" class="thumb1 b">
                      <img
                        :src="`/${item.thumbnailPath}/${item.thumbnailName}`"
                        alt=""
                        @error="handleImageError(item)"
                      />
                    </a>
                  </div>
                  <div>
                    <div class="meta1 a">
                      <span class="com_fs14">
                        {{ formatEventDate(item.eventDate) }}
                      </span>
                      <span class="com_tag2">{{ item.subCategoryName }}</span>
                      <span v-if="item.newFlg" class="com_new1">NEW</span>
                      <div v-if="item.closeFlg" class="close-event">
                        受付終了
                      </div>
                    </div>
                    <div class="body1">
                      <h2 class="com_link1">
                        {{ item.contentsTitle }}
                      </h2>
                    </div>
                  </div>
                  <div v-if="isKaunetAdmin" class="edit1">
                    <a
                      href="#"
                      @click.prevent="
                        editContents(item.categoryId, item.contentsId)
                      "
                      class="com_edit1"
                    >
                      <span></span>
                    </a>
                  </div>
                </router-link>
              </div>
            </template>

            <template v-else>
              <!-- 受講履歴 -->
              <div class="com_i_title1 a">
                <div>
                  <img
                    src="@/assets/common/img/icon-t-event2.png"
                    alt=""
                    class="icon-t-event2"
                  />
                  <h2>受講履歴</h2>
                </div>
              </div>

              <div class="com_thumb_list1 th1">
                <router-link
                  v-for="item in historyEventListData"
                  :key="item.contentsId"
                  class="item1"
                  :to="`/skilup-event-detail/categoryId/${item.categoryId}/contentsId/${item.contentsId}`"
                >
                  <div>
                    <a href="" class="thumb1 b">
                      <img
                        :src="`/${item.thumbnailPath}/${item.thumbnailName}`"
                        alt=""
                        @error="handleImageError(item)"
                      />
                    </a>
                  </div>
                  <div>
                    <div class="meta1 a">
                      <span class="com_fs14">
                        {{ formatEventDate(item.eventDate) }}
                      </span>
                      <span class="com_tag2">{{ item.subCategoryName }}</span>
                    </div>
                    <div class="body1">
                      <h2 class="com_link1">
                        {{ item.contentsTitle }}
                      </h2>
                    </div>
                  </div>
                  <div v-if="isKaunetAdmin" class="edit1">
                    <a
                      href="#"
                      @click.prevent="
                        editContents(item.categoryId, item.contentsId)
                      "
                      class="com_edit1"
                    >
                      <span></span>
                    </a>
                  </div>
                </router-link>
              </div>
            </template>
          </div>

          <div class="side_search_option1">
            <a href="#" class="com_ln_button1" @click.prevent="toggleScreen">
              <template v-if="isEventList">受講履歴を見る</template>
              <template v-else>イベント一覧を見る</template>
            </a>

            <hr class="sep1" />

            <h2 class="title1">
              <span class="com_icon_option1"></span>さらに絞り込む
            </h2>

            <div class="block_search1">
              <h3 class="title2">キーワードから探す</h3>
              <div>
                <input
                  type="text"
                  name=""
                  placeholder="キーワードを入力"
                  @keyup.enter="narrowSearch"
                  v-model="narrowKeyword"
                  maxlength="50"
                />
                <button type="button" name="" @click="narrowSearch"></button>
              </div>
            </div>

            <div class="block_period1">
              <h3 class="title2">開催日</h3>
              <input
                class="date_edit1"
                type="date"
                name=""
                v-model="eventPeriodFrom"
                :max="AppConstants.MAX_DATE_VALUE"
              />
              <span class="t1">〜</span>
              <input
                class="date_edit1"
                type="date"
                name=""
                v-model="eventPeriodTo"
                :max="AppConstants.MAX_DATE_VALUE"
              />
              <!-- エラーメッセージの表示エリア -->
              <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
              </div>
              <label v-if="isKaunetAdmin" class="com_checkbox1">
                <input type="checkbox" name="" v-model="isOutsideEventPeriod" />
                <span class="t2">開催期間外も表示する</span>
              </label>
              <button type="button" class="button1" @click="narrowSearch">
                検索
              </button>
            </div>

            <div class="block_options_group1">
              <div class="com_center1 com_mgb10">
                <a
                  href="#"
                  class="option_uncheck_all1 com_link1"
                  @click.prevent="uncheckAll"
                >
                  <span class="com_icon_cross1"></span>チェックを外す
                </a>
              </div>
              <h3 class="title2">カテゴリーから探す</h3>
              <div
                v-for="(group, index) in groupedTags"
                :key="index"
                class="option_group1"
              >
                <div class="hd1">
                  <label class="com_checkbox1">
                    <input
                      type="checkbox"
                      v-model="group.isCategoryChecked"
                      @change="toggleCategory(group)"
                    />
                    <span class="t1">
                      {{ group.categoryName }}
                    </span>
                  </label>
                </div>
                <div class="body1">
                  <label
                    v-for="(tag, idx) in group.tags"
                    :key="idx"
                    class="com_checkbox1"
                  >
                    <input
                      type="checkbox"
                      v-model="tag.isChecked"
                      @change="checkCategoryStatus(group, tag)"
                    />
                    <span class="t2">{{ tag.tagName }}</span>
                  </label>
                </div>
              </div>
              <hr />
              <button type="button" class="button1" @click="narrowSearch">
                検索
              </button>
              <div class="com_center1 com_mgt5">
                <a
                  href="#"
                  class="option_uncheck_all1 com_link1"
                  @click.prevent="uncheckAll"
                >
                  <span class="com_icon_cross1"></span>チェックを外す
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div v-if="isDataFetched">
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  sanitizeInput,
  getTargetDate,
  scrollToTop,
  isTokenAlive,
  trimKeyword,
  commonHandleAxiosError,
} from "@/Common";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import { AppConstants } from "@/constants/AppConstants";
import BackToTop from "../controls/BackToTop.vue";
import { useProcessingStore } from "../../store/useProcessingStore";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useUserStore } from "@/store/userStore";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface ContentsItem {
  categoryId: string;
  categoryName: string;
  subCategoryName: string;
  contentsId: string;
  contentsTitle: string;
  thumbnailPath: string;
  thumbnailName: string;
  eventDate: string;
  newFlg: boolean;
  closeFlg: boolean;
}

interface TagItem {
  categoryId: string;
  categoryName: string;
  tagId: string;
  tagName: string;
  isChecked: boolean;
}

interface CategoryGroup {
  categoryId: string;
  categoryName: string;
  tags: TagItem[];
  isCategoryChecked: boolean;
}

export default defineComponent({
  name: "SkilupEventComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const { logoutUser } = useUserStore();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { getCategoryIdByName } = useUserParmitionStore();
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const apiErrorMessage = ref(""); // エラーメッセージ（ページの真ん中にでるやつ）
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡

    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const categoryId = ref("");
    const isApplicationEventOpen = ref(false);
    const isEventList = ref(true); // イベント一覧表示フラグ

    const eventListData = ref<ContentsItem[]>([]); // イベント一覧データ
    const applicationEventListData = ref<ContentsItem[]>([]); // 申込済みイベント一覧データ
    const historyEventListData = ref<ContentsItem[]>([]); // 受講履歴データ
    const eventTagListData = ref<TagItem[]>([]); // タグデータ（イベント一覧）
    const historyEventTagListData = ref<TagItem[]>([]); // タグデータ（受講履歴）
    const appDispCount = ref(0);
    const isLoading = ref(false);

    // イベント一覧の絞込条件
    const eventListDataSearchCriteria = ref({
      narrowKeyword: "",
      eventPeriodFrom: "",
      eventPeriodTo: "",
      isOutsideEventPeriod: false,
    });
    // 受講履歴の絞込条件
    const historyEventListDataSearchCriteria = ref({
      narrowKeyword: "",
      eventPeriodFrom: "",
      eventPeriodTo: "",
      isOutsideEventPeriod: false,
    });

    const narrowKeyword = ref(""); // 絞込キーワード
    const eventPeriodFrom = ref(""); // 開催期間From
    const eventPeriodTo = ref(""); // 開催期間To
    const isOutsideEventPeriod = ref(false); // 開催期間外も表示する

    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;
        isDataFetched.value = false;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);

        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // イベントのカテゴリIDを取得
        categoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_EVENT
        ) as string;

        // 初期表示イベント一覧取得
        const response = await apiAuthClient.post(
          "/api/Event/getInitialDisplayEventList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: categoryId.value,
            narrowKeyword: "",
            narrowTags: "",
            targetDate: getTargetDate(""),
            eventPeriodFrom: "",
            eventPeriodTo: "",
            isOutsideEventPeriod: false,
          }
        );

        // レスポンスからデータを取得
        const data = response.data;
        // イベント一覧
        eventListData.value = data.eventListData;
        // イベント一覧のタグ一覧
        eventTagListData.value = data.eventTagListData;
        // 受講履歴
        historyEventListData.value = data.historyEventListData;
        // 受講履歴のタグ一覧
        historyEventTagListData.value = data.historyEventTagListData;
        // 申込済みイベント一覧
        applicationEventListData.value = data.applicationEventListData;
        // 申込済みイベントの表示件数
        appDispCount.value = data.appDispCount;

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
        isEventList.value = true; // イベント一覧を表示
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 416:
              // 検索件数オーバー
              apiErrorMessage.value = formatMessage(
                messages.ERR_0023,
                "イベント一覧"
              );
              break;
            default:
              // ほかのエラー
              handleAxiosError(error);
          }
        } else {
          handleAxiosError(error);
        }
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * 絞込検索実行
     */
    const narrowSearch = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // ------- for debug --------
        outputDebugLogs("絞込検索");
        outputDebugLogs("開催期間FROM：" + eventPeriodFrom.value);
        outputDebugLogs("開催期間TO：" + eventPeriodTo.value);
        outputDebugLogs("キーワード：" + narrowKeyword.value);
        outputDebugLogs("絞込タグ：" + selectedTagIds.value);
        outputDebugLogs("開催期間外も表示する：" + isOutsideEventPeriod.value);
        outputDebugLogs("絞込対象：" + isEventList.value);
        // ------- for debug --------

        // エラーメッセージを初期化
        errorMessage.value = "";
        apiErrorMessage.value = "";

        if (eventPeriodFrom.value && eventPeriodTo.value) {
          // 両方の値が入力されている場合、大小チェックを行う
          if (
            new Date(eventPeriodFrom.value) <= new Date(eventPeriodTo.value)
          ) {
            // チェックOK
          } else {
            errorMessage.value = formatMessage(
              messages.ERR_0005,
              "開催期間From",
              "開催期間To"
            );
            return;
          }
        } else if (eventPeriodFrom.value && !eventPeriodTo.value) {
          // Fromだけが入力されている場合、Toの値を最大値に設定
          eventPeriodTo.value = "9999-12-31";
        } else if (!eventPeriodFrom.value && eventPeriodTo.value) {
          // Toだけが入力されている場合、Fromの値を最小値に設定
          eventPeriodFrom.value = "2001-01-01";
        }

        // キーワードをサニタイジング
        const sanitizedKeyWord = trimKeyword(
          sanitizeInput(narrowKeyword.value, true)
        );
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 1文字の場合はNG
        if (sanitizedKeyWord.length == 1) {
          errorMessage.value = formatMessage(
            messages.ERR_0028,
            "キーワード",
            "2"
          );
          return;
        }

        // API-URL
        const url = isEventList.value
          ? "/api/Event/getSkilupEventList"
          : "/api/Event/getSkilupHistoryEventList";

        // イベント一覧取得
        const response = await apiAuthClient.post(url, {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          categoryId: categoryId.value,
          narrowKeyword: sanitizedKeyWord,
          narrowTags: selectedTagIds.value,
          eventPeriodFrom: eventPeriodFrom.value,
          eventPeriodTo: eventPeriodTo.value,
          isOutsideEventPeriod: isOutsideEventPeriod.value,
          targetDate: getTargetDate(""),
        });

        // レスポンスからデータを取得
        const data = response.data;
        if (isEventList.value) {
          // イベント一覧
          eventListData.value = data.eventListData;
        } else {
          // 受講履歴
          historyEventListData.value = data.historyEventListData;
        }
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 416:
              // 検索件数オーバー
              apiErrorMessage.value = formatMessage(
                messages.ERR_0023,
                isEventList.value ? "イベント一覧" : "受講履歴"
              );
              break;
            default:
              // ほかのエラー
              handleAxiosError(error);
          }
        } else {
          handleAxiosError(error);
        }
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * カテゴリIDでグループ化したタグのリスト
     */
    const groupedTags = computed(() => {
      const groups: CategoryGroup[] = [];
      const categoryMap: Record<string, CategoryGroup> = {};

      const tagListData = isEventList.value
        ? eventTagListData.value
        : historyEventTagListData.value;

      tagListData.forEach((item) => {
        if (!categoryMap[item.categoryId]) {
          categoryMap[item.categoryId] = {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            tags: [],
            isCategoryChecked: false,
          };
          groups.push(categoryMap[item.categoryId]);
        }
        categoryMap[item.categoryId].tags.push(item);
      });

      // Set initial category checked status based on tags
      groups.forEach((group) => {
        group.isCategoryChecked = group.tags.every((tag) => tag.isChecked);
      });

      return groups;
    });

    /**
     * カテゴリIDのチェックON・OFFで紐づいているタグのチェックをON・OFFする
     * @param group
     */
    const toggleCategory = (group: CategoryGroup) => {
      group.tags.forEach((tag) => {
        tag.isChecked = group.isCategoryChecked;
        toggleTag(tag);
      });
    };

    /**
     * 同じタグIDのチェック状態を更新する
     * @param tag
     * @param tagListData
     */
    const toggleTag = (tag: TagItem) => {
      const tagListData = isEventList.value
        ? eventTagListData.value
        : historyEventTagListData.value;

      tagListData.forEach((item) => {
        if (item.tagId === tag.tagId) {
          item.isChecked = tag.isChecked;
        }
      });
    };

    /**
     * カテゴリのチェック状態
     * @param group
     * @param tag
     * @param tagListData
     */
    const checkCategoryStatus = (group: CategoryGroup, tag: TagItem) => {
      group.isCategoryChecked = group.tags.every((tag) => tag.isChecked);
      toggleTag(tag);
    };

    /**
     * すべてのタグの選択状態を解除します
     */
    const uncheckAll = () => {
      groupedTags.value.forEach((group) => {
        group.isCategoryChecked = false;
        group.tags.forEach((tag) => {
          tag.isChecked = false;
        });
      });
    };

    /**
     * 選択されているタグIDをカンマ区切りで取得します
     */
    const selectedTagIds = computed(() => {
      return groupedTags.value
        .flatMap((group) => group.tags)
        .filter((tag) => tag.isChecked)
        .map((tag) => tag.tagId)
        .join(",");
    });

    /**
     * コンテンツ編集
     * コンテンツ登録画面に編集モードで遷移します
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const editContents = (ctgyId: string, ctsId: string) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);

        // イベント登録画面へ編集モードで遷移
        router.push({
          path: "/event-touroku",
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 申込済みイベント一覧の表示件数制御
     */
    const applicationEventDisplayedList = computed(() => {
      return isApplicationEventOpen.value
        ? applicationEventListData.value
        : applicationEventListData.value.slice(0, appDispCount.value);
    });

    /**
     * 申込済みイベント一覧のもっと見る／閉じるボタン押下
     */
    const toggleApplicationEventOpen = () => {
      isApplicationEventOpen.value = !isApplicationEventOpen.value;
    };

    /**
     * イベント一覧／受講履歴ボタン押下
     */
    const toggleScreen = () => {
      // エラーメッセージを初期化
      errorMessage.value = "";
      apiErrorMessage.value = "";

      // 絞込条件を退避
      const saveSearchCriteria = isEventList.value
        ? eventListDataSearchCriteria.value
        : historyEventListDataSearchCriteria.value;

      saveSearchCriteria.narrowKeyword = narrowKeyword.value;
      saveSearchCriteria.eventPeriodFrom = eventPeriodFrom.value;
      saveSearchCriteria.eventPeriodTo = eventPeriodTo.value;
      saveSearchCriteria.isOutsideEventPeriod = isOutsideEventPeriod.value;

      // 画面表示を切替え
      isEventList.value = !isEventList.value;

      // 絞込条件を復元
      const restoreSearchCriteria = isEventList.value
        ? eventListDataSearchCriteria.value
        : historyEventListDataSearchCriteria.value;

      narrowKeyword.value = restoreSearchCriteria.narrowKeyword;
      eventPeriodFrom.value = restoreSearchCriteria.eventPeriodFrom;
      eventPeriodTo.value = restoreSearchCriteria.eventPeriodTo;
      isOutsideEventPeriod.value = restoreSearchCriteria.isOutsideEventPeriod;

      // スクロールを一番上に戻す
      scrollToTop();
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      apiErrorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * サムネイルが無い時の処理
     * @param item
     */
    const handleImageError = (item: ContentsItem) => {
      item.thumbnailPath = "WITH_AG_PORTAL/images";
      item.thumbnailName = "no-image1.png";
    };

    /**
     * イベント開催日の日付フォーマット
     * @param dateString
     */
    const formatEventDate = (dateString: string): string => {
      // 入力の日付文字列を Date オブジェクトに変換
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return "";
      }

      // 曜日を取得
      const daysOfWeek = ["日", "月", "火", "水", "木", "金", "土"];
      const dayOfWeek = daysOfWeek[date.getDay()];

      // フォーマットに合わせて出力
      const formattedDate = `${date.getFullYear()}.${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}.${date
        .getDate()
        .toString()
        .padStart(2, "0")}（${dayOfWeek}）`;

      return formattedDate;
    };

    return {
      isInitError,
      isKaunetAdmin,
      errorMessage,
      apiErrorMessage,
      isDataFetched,
      groupedTags,
      toggleCategory,
      checkCategoryStatus,
      uncheckAll,
      narrowSearch,
      editContents,
      toggleApplicationEventOpen,
      toggleScreen,
      narrowKeyword,
      eventPeriodFrom,
      eventPeriodTo,
      isOutsideEventPeriod,
      eventListData,
      applicationEventListData,
      applicationEventDisplayedList,
      historyEventListData,
      appDispCount,
      isApplicationEventOpen,
      isEventList,
      formatEventDate,
      AppConstants,
      handleImageError,
      isLoading,
    };
  },
});
</script>

<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}

.close-event {
  margin-left: auto;
  margin-right: 30px;
  background: #4b5165;
  border: 1px solid #666;
  border-radius: 3px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  height: 21px;
  letter-spacing: 0.03em;
  line-height: 18px;
  min-width: 115px;
  padding: 0 0.5em;
  text-align: center;
}

.open .com_more_button2:after {
  border-color: transparent #000 #000 transparent;
  border-style: solid;
  border-width: 0 1.2px 1.2px 0;
  content: "";
  display: inline-block;
  height: 8.5px;
  margin: 4px 0 0 10px;
  position: relative;
  transform: rotate(-135deg);
  transition: 0.3s ease;
  vertical-align: middle;
  width: 8.5px;
}
</style>
